import {
  Shapes,
  Star,
  BookOpen,
  Calculator,
  Globe,
  MusicNotes,
  PencilSimple,
  Trophy,
  Lightbulb,
  PuzzlePiece,
  Microphone,
  Rocket,
  Flask,
  Leaf,
  Confetti,
  Smiley,
  Compass,
  Palette,
} from "@phosphor-icons/react";
import { SectionShell } from "../Primitives";

const ICONS = [
  BookOpen, Calculator, Globe, MusicNotes, PencilSimple, Trophy,
  Lightbulb, PuzzlePiece, Microphone, Rocket, Flask, Leaf,
  Confetti, Smiley, Compass, Palette,
];

const WEIGHTS = ["thin", "light", "regular", "bold", "fill", "duotone"];

export function IconSection() {
  return (
    <SectionShell
      id="icons"
      eyebrow="Iconography"
      eyebrowIcon={Shapes}
      title="Rounded icons with a friendly weight"
      description="We use Phosphor icons for their soft, rounded geometry. Bold weight for resting states, Fill for active/selected — always paired with a text label so meaning is never lost."
    >
      <div className="rounded-3xl border border-border bg-card p-6 shadow-soft md:p-8">
        <div className="grid grid-cols-4 gap-3 sm:grid-cols-6 lg:grid-cols-8">
          {ICONS.map((Icon, i) => (
            <div
              key={i}
              className="flex aspect-square items-center justify-center rounded-2xl bg-muted/50 text-foreground transition-all duration-200 ease-bounce hover:-translate-y-1 hover:bg-primary/12 hover:text-primary-strong"
            >
              <Icon size={28} weight="bold" />
            </div>
          ))}
        </div>
      </div>

      <div className="mt-5 grid gap-5 md:grid-cols-2">
        <div className="rounded-3xl border border-border bg-card p-6 shadow-soft">
          <p className="mb-4 text-sm font-bold uppercase tracking-wider text-muted-foreground">Weights</p>
          <div className="flex items-end justify-between gap-2">
            {WEIGHTS.map((w) => (
              <div key={w} className="flex flex-col items-center gap-2">
                <Star size={34} weight={w} className="text-primary" />
                <span className="text-xs font-bold capitalize text-muted-foreground">{w}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-3xl border border-border bg-card p-6 shadow-soft">
          <p className="mb-4 text-sm font-bold uppercase tracking-wider text-muted-foreground">Rules of thumb</p>
          <ul className="space-y-3 font-medium text-muted-foreground">
            <li className="flex gap-3"><span className="text-primary-strong">●</span> 24px default, 20px inline, 32px+ feature.</li>
            <li className="flex gap-3"><span className="text-primary-strong">●</span> Bold = inactive · Fill = active/selected.</li>
            <li className="flex gap-3"><span className="text-primary-strong">●</span> Always inside a ≥48px touch target.</li>
            <li className="flex gap-3"><span className="text-primary-strong">●</span> Pair with a label — icons aren&apos;t a language yet.</li>
          </ul>
        </div>
      </div>
    </SectionShell>
  );
}

export default IconSection;
